document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.marquee__track');

  const distance = track.scrollWidth / 2;

  track.animate(
    [
      { transform: 'translateX(0)' },
      { transform: `translateX(-${distance}px)` }
    ],
    {
      duration: 15000,
      iterations: Infinity,
      easing: 'linear'
    }
  );
});